import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface StatusStats {
  [key: string]: number;
}

interface ClientStatusStatsProps {
  statusStats: StatusStats;
  getStatusLabel: (status: string) => string;
  getStatusColor: (status: string) => string;
  onStatusFilter?: (status: string) => void;
  className?: string;
}

export function ClientStatusStats({ 
  statusStats, 
  getStatusLabel, 
  getStatusColor, 
  onStatusFilter,
  className 
}: ClientStatusStatsProps) {
  if (Object.keys(statusStats).length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className="flex flex-wrap gap-1.5 items-center">
        <span className="text-xs text-muted-foreground ml-2">إحصائيات:</span>
        {Object.entries(statusStats).map(([status, count]) => (
          <div key={status} className="relative">
            {onStatusFilter ? (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onStatusFilter(status)}
                className={`h-6 px-2 py-1 text-xs hover:scale-105 transition-all ${getStatusColor(status)} border rounded-md`}
              >
                <span className="truncate max-w-[60px]">{getStatusLabel(status)}</span>
                <span className="bg-white/50 dark:bg-black/50 text-xs px-1 py-0.5 rounded-full font-semibold min-w-[16px] text-center leading-none ml-1">
                  {count}
                </span>
              </Button>
            ) : (
              <div className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-md border ${getStatusColor(status)}`}>
                <span className="truncate max-w-[60px]">{getStatusLabel(status)}</span>
                <span className="bg-white/50 dark:bg-black/50 text-xs px-1 py-0.5 rounded-full font-semibold min-w-[16px] text-center leading-none">
                  {count}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}